import { Box, Flex, Text } from '@chakra-ui/react';

import { StopWatchIcon } from '~/features/experiments/ab_plp_redesign_2025/icons';

/**
 * Phase 2's urgency row (Figma 1944:1250 G1, 1944:1264 G2). Campaign-local rather than a palette
 * variant on the shared `EndsSoonEyebrow`, which is fixed to an "Ends soon" label, a tag icon, and
 * an always-on divider: phase 2 needs a stopwatch icon, a per-variant label, and G1 drops the
 * divider entirely so the row can sit beside the CTA.
 */
export function BackToSchool2026Phase2EndsSoon({
  color,
  label,
  showRule = false,
}: {
  color: string;
  label: string;
  /** G2 trails the label with a divider above the headline; G1 sits beside the CTA without one. */
  showRule?: boolean;
}) {
  return (
    <Flex alignItems='center' gap={4} width={showRule ? '100%' : 'auto'}>
      <Flex alignItems='center' color={color} flexShrink={0} gap={2}>
        <StopWatchIcon height='16px' width='16px' aria-hidden />
        <Text
          fontFamily='condensed'
          fontSize='0.9375rem'
          fontWeight='500'
          letterSpacing='0.06em'
          lineHeight={1}
          textTransform='uppercase'
          whiteSpace='nowrap'
        >
          {label}
        </Text>
      </Flex>
      {showRule ? <Box backgroundColor={color} flex={1} height='1px' minWidth={0} opacity={0.6} /> : null}
    </Flex>
  );
}
